define('TescoMobile_Checkout/js/model/insurance',[], function () {
  'use strict';

  return {
    quoteId: null,
    quoteItemId: null,
    filterByType: function (insurances, type) {
      const result = insurances.find(function (insurance) {
        return insurance.type == type;
      });
      if (typeof result !== 'undefined') {
        return result;
      }
      return false;
    },
    getSelected: function (insurances) {
      const selected = insurances.find(function (insurance) {
        return insurance.selected == true;
      });
      if (typeof selected !== 'undefined') {
        return selected.sku;
      }
      return false;
    },
    getReplacementCost: function (insurances) {
      if (insurances.length > 0) {
        return insurances[0].replacement_cost;
      }
      return 0;
    },
    getIsSoldAsTraditional: function (insurances) {
      if (insurances.length > 0) {
        return insurances[0].is_bau_product;
      }
      return false;
    }
  };
});

